import useLang from "../../../hooks/useLang";
import useAssessment from "./useAssessment";
import useNotesBlock from "../useNotesBlock";
import useAnalysesBlock from "./useAnalysesBlock";

const useAssessmentPreview = ({ assessmentId, showAnalyses = true }) => {
  const lang = useLang();
  const assessment = useAssessment({ id: assessmentId });
  const notesArticle = useNotesBlock(assessment);
  const analysesArticle = useAnalysesBlock(assessment);

  let selectivityError;
  if (assessment?.data) {
    if (
      Array.isArray(assessment?.data?.spectrum?.right?.blue_slashes) &&
      assessment?.data?.spectrum?.right?.blue_slashes.length === 0 &&
      Array.isArray(assessment?.data?.spectrum?.left?.blue_slashes) &&
      assessment?.data?.spectrum?.left?.blue_slashes.length === 0
    )
      selectivityError = false;
  }
  if (
    assessment?.data?.notes &&
    (assessment?.data?.notes["selectivity_left"] === "NT" ||
      assessment?.data?.notes["selectivity_right"] === "NT")
  ) {
    selectivityError = true;
  }

  const spectrumArticle = {
    items: {
      id: "spectrum",
      type: "spectrum",
      data: { ...assessment?.data?.spectrum, selectivityError },
    },
  };

  const title = assessment?.isLoading
    ? "..."
    : `${assessment?.data?.participant?.iid} | ${lang(
        "captions.date_of_birth"
      )}: ${assessment?.data?.participant?.date_of_birth},  ${lang(
        "captions." + assessment?.data?.participant?.gender
      )}`;

  const articles = [{ ...spectrumArticle }];

  if (notesArticle != null) {
    articles.push(notesArticle);
  }

  if (showAnalyses && analysesArticle != null) {
    articles.push(analysesArticle);
  }

  return { title, articles };
};

export default useAssessmentPreview;
